import React, { useEffect, useState } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import { renewPaymentLink, composerAct } from '../../../../../../redux/actions'
import { lang } from 'utils/helpers'
import './styles.scss'
import InfoHeaderPayment from '../../Common/InfoHeaderPayment'
import { apiPayment } from 'api'
import { Button } from 'components/Form'
import Nixi1Spinner from 'components/Nixi1Spinner'

const RenewLink = ( { dispatch, user, plugin:{ link, gettingLink, errors }, orderId }) => {
  const newPaymentLink = bindActionCreators(renewPaymentLink, dispatch)
  const composer = bindActionCreators(composerAct, dispatch)
  const [orderInfo, setOrderInfo] = useState({})
  const [orderError, setOrderError] = useState('')

  const renewLink = () => {
    newPaymentLink.renewLink(user, orderId)
  }

  const resetPlugin = () => {
    newPaymentLink.resetLink(user.id)
  }

  const send = () => {
    composer.updateMessage(`${I18n.t('dashboard_link-payment-with-time-10m')}▶️ ${link} ◀️`)
    resetPlugin()
  }

  useEffect(() => {
    getOrder()
    return () => {
      newPaymentLink.resetLink(user.id)
    }
  }, [])

  const getOrder = async () => {
    try{
      const order = await apiPayment.getOrderId({ userId: user._id, orderId })
      setOrderInfo(order.data)

    } catch (error) {
      setOrderError(I18n.t('message_error_data_list_distribution'))
    }
  }

  return (
    <div>
      <InfoHeaderPayment amount={orderInfo.total || 0} date={orderInfo.date || ''} currency={orderInfo.currency} />
      <div className='container-renew-payment'>
        {link ?(
          <div>
            <div className='message-and-close'>
              <div className='legend-message-link'>
                {I18n.t('dashboard_link-payment-with-time-10m')}
              </div>
              <i className='fa fa-times' onClick={resetPlugin} />
            </div>
            <div style={{ marginBottom: '10px' }}>
              <a href={link} target='_blank' rel='noopener noreferrer'>
                {I18n.t('dashboard_verify-that-link-works')}
              </a>
            </div>
          </div>) : (
          <div style={{ fontSize: '12px' }}>
            {I18n.t('plugins_payment_newLinkInfo')}<br/>
            {`${I18n.t('plugins_payment_newLinkEye')}: `}<strong>{` ${I18n.t('plugins_payment_newLinkAlert')}`}</strong>
          </div>
        )}

        {Object.keys(errors).length > 0 && (
          <div className='error-container'>
            {Object.keys(errors).map((e) => (
              <span key={e} className='text-danger'>{I18n.t(`dashboard_errors_${errors[e]}`)}</span>
            ))}
          </div>
        )}

        {orderError.length > 0 && <div className='error-container'>
          <span className='text-danger'>{orderError}</span>
        </div>}

        {gettingLink ? (
          <Nixi1Spinner height='30px' width='100%' />
        ):(
          <div className='container-copy-buttons' style={{ width:'70%', marginTop:'15px' }}>

            <Button primary onClick={link ? send : renewLink} className={'buttonCreateNewPaymentLink'}>
              <label>
                {link ? I18n.t('dashboard_copy-to-chat') : I18n.t('buttons_createRenewPaymentLink')}
              </label>
            </Button>
            {link &&
                <Button
                  className={'buttonCreateNewPaymentLink'}
                  primary
                  onClick={() => {
                    navigator.clipboard.writeText(`${I18n.t('dashboard_link-payment-with-time-10m')}▶️ ${link} ◀️`)
                  }}
                >
                  <label>
                    {lang('messages_link_payment_clipboard')}
                  </label>
                </Button>
            }
          </div>
        )}
      </div>
    </div>
  )
}

export default connect()(RenewLink)
